import logger from "./logger";
import { RepositoryFactory } from "./../repository/RepositoryFactory";
const PageLogRepository = RepositoryFactory.get("PageLog");

/**
 * アクセスログ(ページログ)出力
 */
export default {
  log,
};

/**
 * アクセスログ(ページログ)出力
 * @param {*} params ログ出力パラメータ
 */
async function log(params) {
  logger.debug("[pageLog] params");
  logger.dir(params);
  await PageLogRepository.forPageLog(params);
}
